export enum ErrorsEnum {
  AWS_ERRORS = 'Has AWS errors',
  SALESFORCE_ERRORS = 'Has Salesforce errors',
  NO_ERRORS = 'No errors',
}
